import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import validator from "validator";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import logo from "../Posti_Group.svg.png";
import { alertActions, msgActions, loaderMaskActions } from "../../../redux/actions";

class UnsubscribePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Email: "",
      PipelineId: "",
      submitted: false,
      errorText: "",
      loaderMask: {
        show: false,
        text: ""
      }
    };

    const { dispatch, history } = this.props;
    history.listen((location, action) => {
      // clear alert on location change
      dispatch(alertActions.clear());
    });
  }

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ submitted: true });
    const { Email } = this.state;
    const { location, dispatch } = this.props;
    if (Email && validator.isEmail(Email)) {
      let _searchQry = location.search;
      if (_searchQry) {
        var qs = require("qs");
        let queryObj = qs.parse(_searchQry.substr(1));
        if (queryObj["pipelineid"]) {
          let params = {
            PipelineId: queryObj["pipelineid"],
            Email
          };
          dispatch(loaderMaskActions.show("Unsubscribing E-mail..."));
          axios
            .post("Reporting/definitions/reportingPipelineUnsubscribe", params)
            .then(response => {
              dispatch(loaderMaskActions.hide(""));
              var data = response.data;
              if (data) {
                if (typeof data === "object") {
                  if (data.Errors && data.Errors.length) {
                    dispatch(alertActions.error(data.Errors[0]));
                  } else if (
                    data.Data &&
                    data.Data.Result &&
                    typeof data.Data.Result === "string"
                  ) {
                    dispatch(msgActions.error("Unsubscribe", data.Data.Result));
                  } else if (data.Data) {
                    dispatch(
                      msgActions.success(
                        "Unsubscribe",
                        "Email unsubscribed successfully."
                      )
                    );
                  } else {
                    dispatch(
                      msgActions.error("Unsubscribe", "Unexpected error.")
                    );
                  }
                }
              }
            });
        }
      } else {
        dispatch(msgActions.error("Unsubscribe", "No Pipeline Id exist"));
      }
    } else {
      dispatch(
        msgActions.error("Unsubscribe", "Please enter a valid email address")
      );
    }
  };

  componentDidMount() {
    setTimeout(function() {
      if (window.NTT.NTTLoader) {
        window.NTT.NTTLoader.increment = 1;
        window.NTT.NTTLoader.intervalTime = 200;
        window.NTT.NTTLoader.loadStep("Almost there! 3, 2, 1...", 85, 100);
      }
    }, 500);
    setTimeout(function() {
      if (window.NTT.NTTLoader) {
        window.NTT.NTTLoader.hideLoader();
      }
    }, 1700);
    this.userNameInput && this.userNameInput.focus();
  }

  toggleMsgBox = () => {
    this.props.dispatch(msgActions.clear());
  };

  render() {
    const { unsubscribing, alert, loaderMask, location } = this.props;
    const { Email } = this.state;

    let redirect = false;
    let _searchQry = location.search;
    if (_searchQry) {
      var qs = require("qs");
      let queryObj = qs.parse(_searchQry.substr(1));
      if (!queryObj["pipelineid"]) {
        redirect = true;
      }
    } else {
      redirect = true;
    }
    if (redirect) {
      var _oldHash = localStorage.getItem("LastLocationHash");
      let _lastLocHash = _oldHash ? _oldHash.toString() : "";
      let _search = localStorage.getItem("LastLocationHashSearch") || "";
      return (
        <Redirect
          to={{
            pathname: _lastLocHash,
            search: _search
          }}
        />
      );
    }

    return (
      <div className="loginPageComponent container-fluid fill p_login">
        {loaderMask.show && (
          <div className="opus_loader">
            <div className="lds-spinner">
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
            <div className="lds-text">{loaderMask.text}</div>
          </div>
        )}
        <div className="fill">
          <div
            className="top navbar navbar-fixed-top overHidden"
            role="navigation"
          >
            <div className="row w-100">
              <div className="col-lg-12 text-center">
                <img
                  className="logo"
                  alt="Posti"
                  src={logo}
                  style={{
                    width: "130px"
                  }}
                />
                <span
                  className="navbar-brand-text"
                  style={{
                    width: "130px",
                    color: "#fff",
                    float: "none",
                    verticalAlign: "bottom",
                    lineHeight: "47px"
                  }}
                >
                  Messaging
                </span>
              </div>
            </div>
          </div>
          <div className="contentHeight">
            <div id="content" className="row content fill">
              <div className="w-100">
                <div
                  className="row fill align-items-center"
                  style={{ display: "flex" }}
                >
                  <div className="main-login">
                    <form
                      style={{ minHeight: "auto", padding: 40 }}
                      name="form"
                      className="form-horizontal"
                      autoComplete="off"
                      onSubmit={this.handleSubmit}
                    >
                      <div style={{ margin: "25px 0 10px 0" }}>
                        Please provide your e-mail and press unsubscribe:
                      </div>
                      <div className="form-group" style={{ color: "#ff5b5b" }}>
                        {alert.message}
                      </div>
                      <div className="form-group">
                        <label
                          htmlFor="email"
                          className="cols-sm-2 control-label"
                          style={{ marginBottom: "2px" }}
                        >
                          E-mail
                        </label>
                        <input
                          type="email"
                          name="Email"
                          style={{ width: "calc(100% - 100px)" }}
                          placeholder="Enter Email"
                          ref={input => {
                            this.userNameInput = input;
                          }}
                          value={Email}
                          onChange={this.handleChange}
                        />
                      </div>
                      <button
                        style={{ float: "right", marginTop: "0.5em" }}
                        disabled={unsubscribing}
                        className={
                          "btn btn-lg btn-block login-button" +
                          (unsubscribing ? " loading" : "")
                        }
                      >
                        Unsubscribe
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer overHidden d-lg-block">
            <div className="mt-2 text-center">
              © <span id="companyYear">{new Date().getFullYear()}</span> Posti
              Messaging
            </div>
            <div className="version">
              Version: {window.NTT && window.NTT.version}
            </div>
          </div>
        </div>
        <Modal isOpen={!!this.props.msg.type} toggle={this.toggleMsgBox}>
          <ModalHeader toggle={this.toggleMsgBox}>
            {this.props.msg.header}
          </ModalHeader>
          <ModalBody>
            {this.props.msg.message}
          </ModalBody>
          <ModalFooter className="text-center">
            <button
              type="button"
              className="switchBtn"
              style={{ width: "100px" }}
              onClick={this.toggleMsgBox}
            >
              OK
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { isSubUser } = state.authentication;
  const { alert, loaderMask, unsubscribing, msg } = state;
  return {
    unsubscribing,
    alert,
    msg,
    loaderMask,
    isSubUser
  };
}

const connectedUnsubscribePage = connect(mapStateToProps)(UnsubscribePage);
export { connectedUnsubscribePage as UnsubscribePage };
